<template>
  <div class="familienrecht">
    <header>
      <div class="header-container">
        <div class="image">
          <img
            src="../../src/assets/praxis-lambrette-familienrecht.png"
            alt="Bild Gutachten im Familienrecht"
          />
        </div>
        <div class="text">
          <h1>Gutachten im Familienrecht</h1>
          <p>
            Ich arbeite im Auftrag von Familiengerichten bundesweit als
            psychologische Sachverständige zu Fragen der Erziehungsfähigkeit von
            Eltern, zum Umgangsrecht und zu Fragestellungen aus dem
            Adoptionsrecht. Schwerpunkte meiner Arbeit sind Eltern mit
            psychischen Störungen, binationale Familien sowie lösungsorientierte
            Fragestellungen. Meine Gutachten erstelle ich gemäß den
            <a
              href="https://www.bmj.de/SharedDocs/Downloads/DE/Themen/FamilieUndPartnerschaft/MindestanforderungenSachverstaendigengutachtenKindschaftsrecht.pdf;jsessionid=AF487B32FC29A03B6705D36DF8901157.2_cid334?__blob=publicationFile&v=3"
              target="_blank"
              >aktuellen Mindestanforderungen</a
            >. Ich bin als Fachpsychologin für Rechtspsychologie (BDP/DGPs)
            <a
              href="https://www.rechtspsychologen-register.de/recht/results/?s=bn4dsdf4n7zdh8kbzg9sa7b4tf95feqo44jufl"
              target="_blank"
              >akkreditiert</a
            >
          </p>
        </div>
      </div>
    </header>

    <Contact></Contact>
  </div>
</template>

<script>
import Contact from "../components/Contact.vue";

export default {
  components: {
    Contact
  },
  metaInfo: {
    title: "Gutachten im Familienrecht – Dipl.-Psych. Katrin Lambrette",
    meta: [
      {
        name: "description",
        content:
          "Gutachten im Familenrecht – Ich arbeite im Auftrag von Familiengerichten bundesweit als psychologische Sachverständige zu Fragen der Erziehungsfähigkeit von Eltern, zum Umgangsrecht und zu Fragestellungen aus dem Adoptionsrecht."
      }
    ],
    htmlAttrs: {
      lang: "de",
      amp: true
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  color: $familienrecht-color;
}

header {
  @media screen and (min-width: 992px) {
    .header-container {
      .text {
        background-image: url(../../src/assets/praxis-lambrette-familienrecht-signet-transparent.png);
        background-position: bottom right;
        padding: 0% 10% 0 0;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    .header-container .text {
      padding: 5% 15% 0 0;
    }
  }
}
</style>
